import useDragAndMatchActivity from './useDragAndMatchActivity.hook';
import { StyledDragAndMatchActivity } from './DragAndMatchActivity.styled';
import DragAndMatchGame from './DragAndMatchGame/DragAndMatchGame';
import AspectRatio from '@/shared/AspectRatio/AspectRatio';
import { useContext } from 'react';
import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';

export default function DragAndMatchActivity({
  activity,
  activityConf,
  taskProgressAPI,
  demoMode,
  onFinishedActivity,
}) {
  const { state, actions } = useDragAndMatchActivity({
    taskProgressAPI,
  });
  const fullscreenContext = useContext(FullscreenContext);
  return (
    <StyledDragAndMatchActivity>
      {activity?.id == 28 ? (
        <AspectRatio
          className="aspect-ratio"
          ratio={fullscreenContext.state.isFullscreen ? 16 / 10 : 16 / 11}
        >
          <DragAndMatchGame
            gameAssetsFolder={`${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${
              process.env.NEXT_PUBLIC_ROCKALINGUA_ENVIRONMENT == 'production'
                ? 'production'
                : 'staging'
            }/gamesSrc/classic/assets/${activity.data.lesson}`}
            commonAssetsFolder={
              process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
              '/commonGameAssets/classic'
            }
            activityData={activity.data}
            onAnswer={actions.onAnswer}
            onFinishedActivity={onFinishedActivity}
            activityConf={activityConf}
            language={activity.language}
          />
        </AspectRatio>
      ) : (
        <DragAndMatchGame
          gameAssetsFolder={`${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${
            process.env.NEXT_PUBLIC_ROCKALINGUA_ENVIRONMENT == 'production'
              ? 'production'
              : 'staging'
          }/gamesSrc/classic/assets/${activity.data.lesson}`}
          commonAssetsFolder={
            process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
            '/commonGameAssets/classic'
          }
          activityData={activity.data}
          onAnswer={actions.onAnswer}
          onFinishedActivity={onFinishedActivity}
          activityConf={activityConf}
          language={activity.language}
        />
      )}
    </StyledDragAndMatchActivity>
  );
}
